// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import Link from "@insite/mobius/Link";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import { shareIconStyles } from "@mcmc/XDL/Utilities/sharedStyles";
import React from "react";
import { css } from "styled-components";

interface OwnProps {}

export type Props = OwnProps;

export interface ShareThisButtonStyles {
    wrapper?: InjectableCss;
}

export const shareThisButtonStyles: ShareThisButtonStyles = {};

const styles = shareThisButtonStyles;

const ShareThis: React.FC<Props> = () => {
    const buttonRef = React.createRef<HTMLDivElement>();
    React.useEffect(() => {
        const w = window as any;
        if (w.st) {
            // this because the share button will not be loaded until page referesh
            w.st.initialize();
        }
    }, []);

    React.useEffect(() => {
        if (buttonRef.current) {
            buttonRef.current.setAttribute("data-url", window.location.href);
            buttonRef.current.setAttribute("data-network", "facebook");
        }
    }, [buttonRef]);

    const handleOpenShare = () => {
        if (!buttonRef.current) {
            return;
        }

        const target: any = buttonRef.current.childNodes[0];

        if (!target) {
            return;
        }

        target.click();
    };

    return (
        <StyledWrapper {...styles.wrapper}>
            <div style={{ display: "none" }} ref={buttonRef} className="sharethis-inline-share-buttons" />
            <Link {...shareIconStyles} onClick={handleOpenShare}>
                <VisuallyHidden>{translate("Share this")}</VisuallyHidden>
            </Link>
        </StyledWrapper>
    );
};

export default ShareThis;
